import { FocusEvent, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ListTabItem } from "../../../../../../../components/customeTab/types"
import { useTranslation } from "react-i18next"
import { TabsItemGroup } from "../../../utils/enums/tabs"
import { useFilter } from "../../../../../../../hooks/filter"
import { FilterProps } from "../../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../../utils/types/generals"
import { InputModel } from "../../../../../../../utils/types"
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUserTypes } from "../../../../../../../utils/methods/geServiceWithItemsFormat"
import { Roles, Types } from "../../../../../../../utils/enums"
import { userGroupServiceFetch, userServiceFetch } from "../../../../../../../utils/constants/callService"
import { returnQuery } from "../../../../../../../utils/methods/returnQuery"
import { useNavigate } from "react-router-dom"
import { formatListInternalUsers } from "../../../../../../../service/userGroup/format"
import { InternalListUsers, InternalUser } from "../../../../../../../service/userGroup/response"
import { PageOptionGroup } from "../../../utils/enums/page"

const useBody = ({ id, from, mode }: { id: string | undefined, from: string | null, mode: PageOptionGroup }) => {

    const [valueVame, setValueName] = useState<string>("")
    const [errors, setErrors] = useState<{ name?: string }>({})
    const [tabValue, setTabValue] = useState(TabsItemGroup.INTERNAL_USER);
    const [usersSelected, setUsersSelected] = useState<{ id: number, name: string, rol: string }[]>([])
    const [usersSelectedCopy, setUsersSelectedCopy] = useState<{ id: number, name: string, rol: string }[]>([])
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [allDepartments, setAllDepartments] = useState<Item[]>([])
    const [row, setRow] = useState<{ id: number, users: string, role: string, userType: string }[]>([])
    const [rowDetail, setRowDetail] = useState<{ name: string, role: string, userType: string, areaName: string, departmentName: string }[]>([])
    const [selects, setSelects] = useState<(number | string)[]>([]);
    const [loadingTable, setLoadingTable] = useState(false)
    const [submitLoader, setSubmitLoader] = useState(false)
    const [loaderDetail, setLoaderDetail] = useState(false)
    const [emails, setEmails] = useState<string[]>([]);
    const [emailsCopy, setEmailsCopy] = useState<string[]>([]);
    const [errorsEmail, setErrorsEmail] = useState<string[]>([]);
    const [totalPages, setTotalPages] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const [totalSelected, setTotalSelected] = useState(0)


    const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
        loader: boolean
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { },
        loader: false
    })

    const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

    const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

    const listBreadCrumb = useMemo(() => {
        if (mode == PageOptionGroup.CREATE) {
            return [
                {
                    id: 'group-gestion',
                    label: 'group-gestion',
                    navigate: () => { navigate(`/dashboard/user/group-gestion`) }
                },
                {
                    id: 'create',
                    label: 'createGroup',
                    navigate: () => { }
                },
            ]
        } else if (mode == PageOptionGroup.DETAIL) {
            return [
                {
                    id: 'group-gestion',
                    label: 'group-gestion',
                    navigate: () => { navigate(`/dashboard/user/group-gestion`) }
                },
                {
                    id: 'detail',
                    label: 'detailGroup',
                    navigate: () => { }
                },
            ]
        } else {
            if (from === "detail") {
                return [
                    {
                        id: 'group-gestion',
                        label: 'group-gestion',
                        navigate: () => { navigate(`/dashboard/user/group-gestion`) }
                    },
                    {
                        id: 'detail',
                        label: 'detailGroup',
                        navigate: () => { navigate(`/dashboard/user/group-gestion/detail/${id}`) }
                    },
                    {
                        id: 'edit',
                        label: 'editGroup',
                        navigate: () => { }
                    },
                ]
            } else {
                return [
                    {
                        id: 'group-gestion',
                        label: 'group-gestion',
                        navigate: () => { navigate(`/dashboard/user/group-gestion`) }
                    },
                    {
                        id: 'edit',
                        label: 'editGroup',
                        navigate: () => { }
                    },
                ]
            }
        }
    }, [from,mode])

    const [input, setInput] = useState<{ [x: string]: InputModel }>({
        search: {
            label: 'general.searchUsers',
            translate: true,
            name: 'search',
            value: null,
        },
        from: {
            label: 'general.tags.from',
            translate: true,
            name: 'from',
            type: 'date',
            value: null,
            rest: {
                max: 'to',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
        },
        to: {
            label: 'general.tags.to',
            translate: true,
            name: 'to',
            type: 'date',
            value: null,
            rest: {
                min: 'from',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
        },
        role: {
            label: 'general.tags.role',
            translate: true,
            name: 'role',
            type: 'filter-select',
            items: [],
            value: null,
        },
        stores: {
            label: 'general.tags.store',
            translate: true,
            name: 'stores',
            type: 'filter-select',
            items: [],
            value: null,
        },
        division_ids: {
            label: 'general.tags.divisions',
            translate: true,
            name: 'division_ids',
            type: 'filter-select',
            items: [],
            value: null,
        },
        userType: {
            label: 'general.tags.userType',
            translate: true,
            name: 'userType',
            type: 'filter-select',
            items: [],
            value: null,
        },
        area: {
            label: 'general.tags.area',
            translate: true,
            name: 'area',
            type: 'filter-select',
            items: [],
            value: null,
        },
        department: {
            label: 'general.tags.department',
            translate: true,
            name: 'department',
            type: 'filter-select',
            items: [],
            value: null,
        },
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target
        setValueName(value)

        validate(value)
    }

    const handleBlur = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        validate(e.target.value)
    }

    const validate = (value: string) => {
        let newErrors: { name?: string } = {}

        if (!value.trim()) {
            newErrors.name = "required"
        } else if (value.trim().length < 3) {
            newErrors.name = "minLength"
        }

        setErrors(newErrors)
    }

    const tabs: ListTabItem[] = [
        {
            id: TabsItemGroup.INTERNAL_USER,
            label: t('userGroup.tabs.internalUser'),
            value: TabsItemGroup.INTERNAL_USER
        },
        {
            id: TabsItemGroup.EXTERNAL_USER,
            label: t('userGroup.tabs.externalUser'),
            value: TabsItemGroup.EXTERNAL_USER
        },
    ]

    const changeTab = ({ value }: { value: TabsItemGroup }) => {
        setTabValue(value)
    }

    const formatFilter = {
        from: "start_date",
        to: 'end_date',
        status: "status_ids",
        role: "role_ids",
        stores: "store_ids",
        userType: "user_type_ids",
        area: "areas_ids",
        department: "departments_ids"
    }

    const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department } = copyBody
            const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
            let arrayChilds: any[] = []

            area?.forEach((e: any) => {
                const id = e.value
                const childs = allDepartments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })

            setFilterData((prev) => ({
                ...prev,
                department: newDepartments,
            }))

            setInput(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
            copyBody = {
                ...copyBody,
                department: newDepartments,
            }
        }

        return copyBody
    }

    const createFilter = useFilter({
        formatFilter,
        externalValidation,
        defaultPagination: { pageSize: 500 }
    })

    const handleSelects = useCallback((value: number[]) => {
        setSelects(value);
    }, []);

    const searchUsers = useCallback(async () => {
        try {
            setLoadingTable(true)
            const response = await userServiceFetch.filterUsers({ query: `status_ids=1&${returnQuery(createFilter.query, {})}` })
            let allUsers = response?.map(item => ({
                id: item.id,
                users: item.fullName,
                userType: item.userType ?? '',
                role: item.role ?? '',
            })) ?? []
            if (!!allUsers?.length) {
                setRow(allUsers)
            } else {
                setRow([])
                setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
            }
        } catch (e) {
            setRow([])
            setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
        }
        finally {
            setLoadingTable(false)
        }
    }, [createFilter.query]);

    const getAllDepartments = async () => {
        const items = await getDepartments()
        setAllDepartments(items)
    }

    const getAllUnits = async () => {
        const { items } = await getStore()
        setInput(prev => ({ ...prev, stores: { ...prev.stores, items } }))
    }

    const getAllUserTypes = async () => {
        const { items } = await getUserTypes()
        setInput(prev => ({ ...prev, userType: { ...prev.userType, items } }))
    }

    const getAllRoles = async () => {
        const { items } = await getRoles({ skip: [Roles.ADMIN] })
        setInput(prev => ({ ...prev, role: { ...prev.role, items } }))
    }

    const getAlDivisions = async () => {
        const { items } = await getDivisions()
        setInput(prev => ({ ...prev, division_ids: { ...prev.division_ids, items } }))
    }

    const getAllAreas = async () => {
        const items = await getArea()
        setInput(prev => ({ ...prev, area: { ...prev.area, items: items } }))
    }

    const getData = () => {
        getAllUnits()
        getAllUserTypes()
        getAllRoles()
        getAllAreas()
        getAllDepartments()
        getAlDivisions()
    }

    const deleteUser = useCallback((id: number) => {
        setUsersSelected(prev =>
            prev.filter(user => user.id !== id)
        );
    }, []);

    const deleteAllUser = useCallback((ids: number[]) => {
        setUsersSelected(prev =>
            prev.filter(user => !ids.includes(user.id))
        );
    }, []);

    const handleAddUser = useCallback(() => {
        setUsersSelected(prev => {
            const existingIds = new Set(prev.map(u => u.id));

            const idsToAdd = selects.filter(id => !existingIds.has(Number(id)));

            const newUsers = idsToAdd
                .map(id => row.find(item => item.id === Number(id)))
                .filter(Boolean)
                .map(item => ({
                    id: item!.id,
                    name: item!.users,
                    rol: item!.role,
                }));

            return [...prev, ...newUsers];
        });
        setSelects([])
    }, [selects, row]);

    const rowMemo = useMemo(() => row, [row]);
    const selectsMemo = useMemo(() => selects, [selects]);
    const inputMemo = useMemo(() => input, [input]);
    const createFilterMemo = useMemo(() => createFilter, [createFilter.query]);

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [mode])

    const handleBack = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t(`userGroup.modal.titles.${from === "detail" ? 'backToDetail' : 'backToList'}`),
            description: t(`userGroup.modal.description.${from === "detail" ? 'backToDetail' : 'backToList'}`),
            cancel: closeModal,
            confirm: () => {
                if (from === "detail") {
                    navigate(`../detail/${id}`);
                } else {
                    navigate(`../`);
                }
                closeModal()
            }
        }))
    }

    const handleSubmit = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t(`userGroup.modal.titles.${id ? 'areYouSureWantEditThisGroup' : 'areYouSureWantCreateThisGroup'}`),
            description: '',
            cancel: closeModal,
            confirm: () => {
                if (id) {
                    edit()
                } else {
                    create()
                }
                closeModal()
            }
        }))
    }

    const create = async () => {

        setSubmitLoader(true)

        const body = {
            name: valueVame,
            usersExtern: emails,
            usersIntern: usersSelected.map(item => item.id)
        }

        const response = await userGroupServiceFetch.createUserGroup(body)

        if (!response.errors && response.code == '00') {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.create.success"), type: Types.SUCCESS }))
            setTimeout(() => {
                navigate('../');
            }, 3000);
        } else {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.create.error"), type: Types.ERROR }))
        }

        setSubmitLoader(false)
    }

    const edit = async () => {

        setSubmitLoader(true)

        const diffStrings = (current: string[], prev: string[]) => {
            return current.filter(item => !prev.includes(item));
        };

        const diffUsers = (
            current: { id: number, name: string, rol: string }[],
            prev: { id: number, name: string, rol: string }[]
        ) => {
            return current
                .filter(item => !prev.some(p => p.id === item.id))
                .map(item => item.id);
        };

        const body = {
            name: valueVame,
            newsUsersExternal: diffStrings(emails, emailsCopy),
            deleteUsersExternal: diffStrings(emailsCopy, emails),
            newsUsersInternal: diffUsers(usersSelected, usersSelectedCopy),
            deleteUsersInternal: diffUsers(usersSelectedCopy, usersSelected),
        }
        const response = await userGroupServiceFetch.updateUserGroup(body, Number(id))

        if (!response.errors && response.code == '01') {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.edit.success"), type: Types.SUCCESS }))
            setTimeout(() => {
                if (from === "detail") {
                    navigate(`../detail/${id}`);
                    getGroupList()
                    createFilter.cleanFilter()
                    createFilterMemo.cleanFilter()
                } else {
                    navigate(`../`);
                }
            }, 3000);
        } else {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.edit.error"), type: Types.ERROR }))
        }

        setSubmitLoader(false)
    }

    const getDetail = async () => {

        setLoaderDetail(true)

        const responseDetail = await userGroupServiceFetch.getUserGroupById(Number(id))
        const responseExternal = await userGroupServiceFetch.getUserGroupExternal(Number(id))

        if (!responseDetail.errors && !responseExternal.errors) {
            setValueName(responseDetail.name)
            setEmails(responseExternal)
            setEmailsCopy(responseExternal)
        }

        if (mode == PageOptionGroup.EDIT) {
            const responseInternal = await userGroupServiceFetch.getUserGroupInternal({ id: Number(id) })

            if (!responseInternal.errors) {
                setUsersSelected(
                    (responseInternal as InternalUser[]).map(item => ({
                        id: item.id,
                        name: `${item.firstName} ${item.lastName}`,
                        rol: item.role.description ?? ''
                    }))
                );
                setUsersSelectedCopy(
                    (responseInternal as InternalUser[]).map(item => ({
                        id: item.id,
                        name: `${item.firstName} ${item.lastName}`,
                        rol: item.role.description ?? ''
                    }))
                );
            }
        }

        setLoaderDetail(false)
    }

    const filterUserInternal = useFilter({ formatFilter: {} })

    const goToEdit = () => {
        navigate(`../edit/${id}?from=detail`)
    }

    const handleDelete = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('userGroup.modal.titles.areYouSureWantDeleteThisGroupSelected'),
            description: t('userGroup.modal.description.areYouSureWantDeleteThisGroupSelected'),
            confirm: () => { handleDeleteUnique() },
            cancel: closeModal,
        }))
    }

    const handleDeleteUnique = async () => {
        setModal(prev => ({ ...prev, loader: true }))

        const response = await userGroupServiceFetch.deleteGroupById(Number(id))

        if (!response.errors && response.code == '01') {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.delete.success"), type: Types.SUCCESS }))
            setTimeout(() => {
                navigate('../');
            }, 3000);
        } else {
            setSnackbar(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.delete.error"), type: Types.ERROR }))
        }

        setModal(prev => ({ ...prev, loader: true, open: false }))
    }

    const getGroupList = async () => {
        setIsLoading(true)
        const response = await userGroupServiceFetch.getUserGroupInternal({ id: Number(id), query: returnQuery({ ...filterUserInternal.query, filter: filterUserInternal.query.filter?.replaceAll('+', '%2B') }) })

        const { row, totalPages, totalSelected } = formatListInternalUsers({ response: response as InternalListUsers })

        setRowDetail(row)
        setTotalPages(totalPages)
        setTotalSelected(totalSelected)

        setIsLoading(false)

    }

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            if (mode == PageOptionGroup.DETAIL) { getGroupList() }
        }, 300)
    }, [filterUserInternal.query.all])


    return { listBreadCrumb, totalSelected, rowDetail, isLoading, totalPages, filterUserInternal, submitLoader, loaderDetail, handleDelete, goToEdit, handleSubmit, handleBack, modal, closeModal, errorsEmail, setErrorsEmail, emails, setEmails, deleteUser, deleteAllUser, rowMemo, selectsMemo, inputMemo, createFilterMemo, handleAddUser, loadingTable, snackbar, closeSnackbar, handleSelects, selects, row, searchUsers, input, createFilter, valueVame, setValueName, handleChange, errors, handleBlur, changeTab, tabs, tabValue, usersSelected, setUsersSelected }
}



export { useBody }